import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Purecss from 'purecss'
import SmoothScrollbar from 'vue-smooth-scrollbar' 
Vue.use(SmoothScrollbar)

import { Lazyload } from 'vant';
Vue.use(Lazyload);
import 'purecss/build/grids-responsive-min.css'
import './theme.css'
import './style.css'
Vue.config.productionTip = false
Vue.use(Purecss);
Vue.use(VueAxios, axios)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
